
<div>
  <checkbox v-for="(option, index) in options"
            :key="option.value"
            ref="checkboxes"
            @check="onCheck"
            @uncheck="onUncheck"
            :value="option.value"
            :id="`${id}_${index + 1}`"
            :name="name">
    {{ option.label }}
  </checkbox>
</div>
